(function () {
    'use strict';
    
    angular
    .module('laekkerAI.tablet')
    .controller('GoodsReceivingController', [
        GoodsReceivingController
    ]);

    function GoodsReceivingController() {
        var $ctrl = this;
    
        $ctrl.$onInit = function () {
        };
    
        $ctrl.$onChanges = function(changes) {
        };
    
        $ctrl.$onDestroy = function () {
        };
    
    }
}());